import { onRequest, RequestMethod } from 'common/axios/axios';
import { getApiUrl, getServiceId } from 'common/axios/getApiUrl';

export type PopupActionType = 'VIEW' | 'CLICK' | 'CLOSE' | 'TODAY' | 'NEVER';

/**
 * wiz-common AppPopup API 래퍼.
 * - active: 현재 활성 + targetType + 사용자별 NEVER/TODAY 자동 필터링된 목록
 * - action: 사용자 액션 기록 (CLOSE 단순 닫기 / NEVER 다시 안 보기 / TODAY 오늘 하루)
 */
export class PopupRepository {
    static onGetActive = (userId?: string, locale = 'ko') => {
        const params = new URLSearchParams({ locale });
        if (userId) params.set('userId', userId);
        return onRequest({
            url: `${getApiUrl('appPopupActive')}/${getServiceId()}?${params.toString()}`,
            method: RequestMethod.GET,
        });
    };

    static onPostAction = (popupId: number | string, actionType: PopupActionType, userId: string) => {
        return onRequest({
            url: `${getApiUrl('appPopupAction')}/${popupId}/action/${actionType}?userId=${encodeURIComponent(userId)}`,
            method: RequestMethod.POST,
        });
    };
}
